import { Message } from 'element-ui';

export function err(str) {
  Message({message: str, type: 'error'})
}
export function success(str) {
  Message({message: str, type: 'success'})
}
export default {
  err: err,
  success: success
}



// WEBPACK FOOTER //
// ./src/tool/toast.js